var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionArrowPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4332 19.8284L22.2921 14.1026C22.4236 13.9741 22.4236 13.7663 22.2921 13.6378L21.7381 13.0964C21.6066 12.9679 21.394 12.9679 21.2625 13.0964L16.1954 18.0374L11.1283 13.0964C10.9968 12.9679 10.7841 12.9679 10.6526 13.0964L10.0986 13.6378C9.96713 13.7663 9.96713 13.9741 10.0986 14.1026L15.9575 19.8284C16.0891 19.9569 16.3017 19.9569 16.4332 19.8284Z",
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrowPurple);
export default __webpack_public_path__ + "static/media/AccordionArrowPurple.21ed22ebbcd715db1aa94ccfcf44e156.svg";
export { ForwardRef as ReactComponent };